<template>
  <div>
    <acct-search-results
      :query="getSearchResultsQuery()"
      :headless="false"
    ></acct-search-results>
  </div>
</template>

<script>
import AcctSearchResults from "@/views/Components/Acct/SearchResults.vue";

export default {
  props: { customer: null },
  components: { AcctSearchResults },
  data() {
    return {
      acctLedger: null,
    };
  },
  async created() {},
  methods: {
    getSearchResultsQuery() {
      var self = this;

      return {
        currentPage: 1,
        sortOption: "Date:descending",
        customerId: this.customer.id,
      };
    },
  },
};
</script>

<style></style>
